class ScoreData {
    uuid: string;
    uploadDate: Date;
    name: string;

    constructor(uuid: string, name: string) {
        this.uuid = uuid;
        this.uploadDate = new Date();
        this.name = name;
    }
}

export default ScoreData;


class RawScoreData {
    defaultName: string;
    name: string;
    file?: File;
    scoreId?: number;
    fileHash?: string;

    constructor(defaultName: string, name: string, file?: File, scoreId?: number, fileHash?: string) {
        this.defaultName = defaultName;
        this.name = name;
        this.file = file;
        this.scoreId = scoreId;
        this.fileHash = fileHash;
    }
}

export {RawScoreData}